import styled from 'styled-components';

export const Container = styled.div`
  margin-right: 20px;
  width: 100px;
  height: 36px;
  color: ${props => (props.isActive ? 'red' : '#d5d5d5')};
`;
